import { OUTCOME_BY_CODE, outcomePillCls } from '../../../data/implantOutcomes.js'
import { OutcomeIcon } from '../../../components/recall/RecallNoteText.jsx'

/* A call result as its chip looks on แท็บรอโทร — the outcome's colour and icon. Shared
 * by ผลการโทร (the log) and ผลเคสปรึกษา (what the calls found). */
export default function ResultPill({ code, small = false, title }) {
  const o = OUTCOME_BY_CODE[code]
  return (
    <span title={title} className={`inline-flex items-center gap-1 whitespace-nowrap rounded border px-1.5 py-px font-medium ${small ? 'text-[10.5px]' : 'text-[11.5px]'} ${outcomePillCls(o?.tone)}`}>
      <OutcomeIcon outcome={o} size={10} />{o?.thai || code}
    </span>
  )
}
